import { ref } from '@vue/composition-api'
import store from '@/store'

export default function usePermissions(ctx) {

  const roles = ref([])
  const privileges = store.getters['auth/menus']


  const requestPrivileges = ref([])

  const tableColumns = ['name', 'action']
  const role = ref(null)

  const errors = ref(null)
  const requestStatus = ref(false)


  requestStatus.value = true
  store.dispatch('roles/getRoles', {
    user: store.getters['auth/user'].id,
    type: 'role'
  })
  .then(res => {
    roles.value = res.data.data
    requestStatus.value = false
  })
  .catch(reason => {
    console.log(reason)
    requestStatus.value = false
  })



  /**
   * push if not exist and remove if exist
   * @param item
   */
  const change = (item) => {
    if(!requestPrivileges.value.includes(item)){
      requestPrivileges.value.push(item)
    }else{
      requestPrivileges.value.splice(requestPrivileges.value.indexOf(item), 1)
    }
  }



  const selectAll = (value) => {
    if (role.value) {
      if (value) privileges.map(p => requestPrivileges.value.push(p))
      else requestPrivileges.value = []
    }
  }



  const getRolePrivileges = () => {
    if (role.value) {
        requestStatus.value = true
        store.dispatch('roles/getPermissions', { role: role.value})
        .then(res => {
            requestPrivileges.value = res.data.permissions
            requestStatus.value = false
        }).catch(reason => {
            console.log(reason)
            requestStatus.value = false
        })
    }
  }




  const submitPrivileges = () => {
    if (role.value) {
      requestStatus.value = true
      store.dispatch('roles/submitPermissions', {
        role: role.value,
        privileges: requestPrivileges.value
      }).then(res => {
          ctx.root.$bvToast.toast(ctx.root.$i18n.t("Successfully updated Role privileges"), {
            title: `Success`,
            variant: 'success', })
          requestStatus.value = false
        })
        .catch(reason => {
          console.log(reason)
          requestStatus.value = false
        })
    }
  }




  return {
    submitPrivileges,
    change, selectAll,
    requestPrivileges,
    getRolePrivileges,
    tableColumns,
    privileges,
    requestStatus,
    errors,
    roles,
    role
  }
}
